import { LOGIN_ACTION } from '../action/login';
import { LOGOUT_ACTION } from '../action/logout';

const initialState = {
  accessToken: '',
  idToken: '',
  expiresAt: '',
  // userPermissions is new field from Cognito
  userPermissions: [],
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_ACTION:
      return {
        ...state,
        ...action.authResult,

        // Auth0 returns expiredIn
        // Cognito returns expiresAt
        expiresAt: action.expiresIn
          ? new Date().getTime() + action.authResult.expiresIn * 1000
          : state.expiresAt,
      };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
